import 'bootstrap';
import Swiper, {Thumbs, Pagination, Navigation, A11y} from 'swiper';

window.jQuery = window.$ = require('jquery');
window.Swiper = Swiper;
window.Thumbs = Thumbs;
window.Pagination = Pagination;
window.Navigation = Navigation;
window.A11y = A11y;
window.BreakpointHelper = require('./helpers/breakpoint');

const processInclude = require('BASE/util');

$.fn.size = function() {
    return this.length;
};

$(document).ready(() => {
    processInclude(require('client/components/menu'));
    require('what-input');
    require('./components/fieldFocusRing')();
    processInclude(require('BASE/components/cookie'));
    processInclude(require('client/components/consentTracking'));
    processInclude(require('BASE/components/collapsibleItem'));
    // processInclude(require('client/components/search'));
    processInclude(require('./components/search'));
    require('./helpers/tomSelectKeyboard')();
    processInclude(require('client/components/clientSideValidation'));
    processInclude(require('BASE/components/toolTip'));
    processInclude(require('client/components/header'));
    processInclude(require('client/components/product-bundle'));
    // processInclude(require('BASE/product/base'));
    processInclude(require('client/components/accordion'));
    processInclude(require('client/components/overlay'));
    // processInclude(require('client/search/search'));
    processInclude(require('client/components/notifications'));
    processInclude(require('client/login/passwordToggle'));
    processInclude(require('client/components/checkout-flow'));
    processInclude(require('client/product/registration'));
    processInclude(require('client/product/accomodations'));
    processInclude(require('client/components/fast-paste'));
    processInclude(require('client/components/text-summary'));
    processInclude(require('client/components/error-reload'));
    processInclude(require('client/components/carousel'));
    processInclude(require('client/components/editorial-map'));
    processInclude(require('client/components/duet-date'));
    // processInclude(require('client/components/bookingDetail'));
    processInclude(require('./dataLayer/dataLayer'));
    processInclude(require('./product/quickView'));
    processInclude(require('./global'));
    processInclude(require('./productDetail'));

    // Page designer script to render departure list via ajax
    processInclude(require('./experience/departureList'));
});

require('client/components/spinner');
require('slick-carousel/slick/slick');
require('tom-select');
require('client/common/common');
require('./app');
require('lazysizes');
